import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, " Test your input lag from the moment you click/tap/press a button to the moment you see the result. ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" This test is not very precise, as it takes "),
  /*#__PURE__*/_createElementVNode("i", null, "you"),
  /*#__PURE__*/_createTextVNode(" into account. Try to be as consistent as possible. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "How to use:"),
  /*#__PURE__*/_createTextVNode(" Press any button when a black rectangle is on the middle line (and the area turns darker), release the button or your finger when the rectangle isn't on the middle line anymore. The yellow rectangles show when you actually pressed or tapped the button. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputLagGame = _resolveComponent("InputLagGame")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_InputLagGame)
  ], 64))
}